module.exports = __webpack_public_path__ + "static/fonts/Fact-NarrowLight.592dbb8.woff2";